module.exports = __webpack_public_path__ + "img/sabina.a4a5fa5b.jpg";